import React from 'react';

import PropTypes from 'prop-types';
import {
  faChevronLeft,
  faChevronRight,
} from '@awesome.me/kit-a6e51d954f/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Button } from '@/components/ui/button';

const DateNav = ({ onDateChange, onDateReset }) => (
  <div className="flex items-center gap-2">
    <Button onClick={onDateReset} variant="outline">
      Today
    </Button>

    <Button onClick={() => onDateChange(-1)} variant="outline">
      <FontAwesomeIcon icon={faChevronLeft} size="xs" />
    </Button>

    <Button onClick={() => onDateChange(1)} variant="outline">
      <FontAwesomeIcon icon={faChevronRight} size="xs" />
    </Button>
  </div>
);

DateNav.propTypes = {
  onDateChange: PropTypes.func.isRequired,
  onDateReset: PropTypes.func.isRequired,
};

export default DateNav;
